import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ReleaseDefinition } from '../models/release-definition';
import { AdoUserProfile } from '../models/ado-user-profile';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SlackService {

  private webHook = environment.slackConfig.slackWebhook;
  private channel = environment.slackConfig.slackChannel;
  private slackTeam = environment.slackConfig.slackTeam;

  private options = {
    headers: new HttpHeaders(
      { 'Content-Type': 'application/x-www-form-urlencoded' },
    ),
    responseType: 'text' as const
  };

  constructor(private http: HttpClient) { }

  sendPipelineReviewRequest(user: AdoUserProfile, org: string, project: string, releaseDefinition: ReleaseDefinition, forceReview: boolean): Observable<string> {
    let message = this.createSlackMessage(user.displayName, org, project, releaseDefinition, forceReview);
    return this.http.post(this.webHook, message, this.options);
  }

  private createSlackMessage(user: string, org: string, project: string, releaseDefinition: ReleaseDefinition, forceReview: boolean): Object {
    let titleText = "review has been requested";
    let notificationText;
    let context = `by ${user} for ${releaseDefinition.name}`;
    let forceReviewText = "";

    if (forceReview) {
      forceReviewText = `*Notes:* Pipeline validation failed   :x:`;
      notificationText = `A pipeline has failed validation and a review has been forcefully requested by ${user} for ${releaseDefinition.name}`;
    } else {
      notificationText = `A pipeline review has been requested by ${user} for ${releaseDefinition.name}`;
    }

    let title = `<!subteam^${this.slackTeam}>\n` + `*A pipeline ${titleText}*`;
    let firstLine = `*User:* ${user}`;
    let secondLine = `*Pipeline:* ${releaseDefinition.name}`;
    let thirdLine = `*Definition Id:* ${releaseDefinition.id}`;
    let fourthLine = `*Org:* ${org}`;
    let fifthLine = `*Project:* ${project}`;

    return {
      channel: this.channel,
      text: notificationText,
      blocks: [
        {
          type: "section",
          text: {
            type: "mrkdwn",
            text: title
          }
        },
        {
          type: "context",
          elements: [
            {
              type: "mrkdwn",
              text: context
            },
            {
              type: "image",
              image_url: `${environment.baseUrl}/assets/platform.png`,
              alt_text: "platform_portal"
            }
          ]
        }
      ],
      attachments: [
        {
          color: "#023075",
          blocks: [
            {
              type: "section",
              text: {
                type: "mrkdwn",
                text: `${forceReviewText}\n${firstLine}\n${secondLine}\n${thirdLine}\n${fourthLine}\n${fifthLine}\n`
              },
            },
            {
              type: "actions",
              elements: [
                {
                  type: "button",
                  text: {
                    type: "plain_text",
                    text: "View Pipeline :azure:",
                    emoji: true
                  },
                  value: "View",
                  action_id: "view",
                  url: `https://dev.azure.com/${org}/${project}/_releaseDefinition?definitionId=${releaseDefinition.id}&_a=environments-editor-preview`
                },
                {
                  type: "button",
                  text: {
                    type: "plain_text",
                    text: "Launch Mario :mario:",
                    emoji: true
                  },
                  value: "Mario",
                  action_id: "mario",
                  url: `${environment.baseUrl}/rcjit/${releaseDefinition.id}`
                }
              ]
            }
          ]
        }
      ]
    };
  }

}
